"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Link = _interopRequireDefault(require("../../Link"));
/* eslint-disable react/prop-types */


var withOptionalLink = function withOptionalLink(BaseComponent) {
  return function (_ref) {
    var url = _ref.url,
        onClick = _ref.onClick,
        target = _ref.target,
        rest = _objectWithoutProperties(_ref, ["url", "onClick", "target"]);

    if (url) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        to: url,
        target: target
      }, /*#__PURE__*/_react.default.createElement(BaseComponent, Object.assign({}, rest, {
        url: url,
        onClick: onClick
      })));
    }

    return /*#__PURE__*/_react.default.createElement(BaseComponent, Object.assign({}, rest, {
      onClick: onClick
    }));
  };
};

var _default = withOptionalLink;
exports.default = _default;